module.exports = __webpack_public_path__ + "static/media/addRegMeetTam.7e0faf6a.jpg";